import $ from "jquery";
import lightGallery from "lightgallery";

$("#reviewSlider").each((_, slider) => {
  $(slider).slick({
    // Параметры настройки слайдера
    dots: false, // Показать точки навигации
    infinite: false, // Зацикливание слайдов
    speed: 500, // Скорость перехода
    slidesToShow: 1, // Количество слайдов для показа
    slidesToScroll: 1, // Количество слайдов для прокрутки
    arrows: true,
    nextArrow: `<svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="slick-next"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M13 18l6 -6" />
        <path d="M13 6l6 6" />
      </svg>`,
    prevArrow: `<svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="slick-prev"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M5 12l6 6" />
        <path d="M5 12l6 -6" />
      </svg>`,
  });

  lightGallery(document.getElementById("lightGallery"), {
    selector: ".slick-slide div > div[data-src]",
    speed: 500,
  });
});
